<template>
	<div class="v-editor" :class="{active}" :style="style">
		<div class="v-editor-head">
			<slot name="head"/>
		</div>
    <div class="v-editor-content" :spellcheck="spellcheck||'false'" :placeholder="placeholder" @focus="active=true" @blur="active=false" ref="content" contenteditable>
      <slot/>
    </div>
		<div class="v-editor-foot">
			<slot name="foot"/>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    width: {
      default: ""
    },
    height: {
      default: ""
    },
    placeholder: {
      default: null
    },
    spellcheck: {
      default: null
    }
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    style() {
      return {
        width: String(this.width).replace(/^(\d+)(px)?$/gm, "$1px"),
        height: String(this.height).replace(/^(\d+)(px)?$/gm, "$1px")
      };
    },
    text() {
      return this.$refs.content ? this.$refs.content.innerText : "";
    },
    html() {
      return this.$refs.content ? this.$refs.content.innerHTML : "";
    }
  },
  mounted() {
    this.$bindEvents(this.$refs.content);
  }
};
</script>

<style lang="less">
.v-editor {
  display: flex;
  font-size: 14px;
  overflow: hidden;
  border-radius: 4px;
  line-height: initial;
  word-break: break-all;
  flex-direction: column;
  border: 1px solid #dddddd;
  &.active {
    border-color: #41b883;
  }
  > .v-editor-head {
    border-bottom: 1px solid #dddddd;
  }
  .v-editor-content {
    flex: 1;
    outline: none;
    overflow: auto;
    padding: 5px 8px;
    min-height: 30px;
    line-height: 20px;
    box-sizing: border-box;
    &[placeholder]:empty::before {
      color: #999999;
      content: attr(placeholder);
    }
  }
  > .v-editor-foot {
    border-top: 1px solid #dddddd;
  }
  > .v-editor-head:empty,
  > .v-editor-foot:empty {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/editor/index.vue